// extracted by mini-css-extract-plugin
export default {"button":"GoHomeBtn_button__rpLq4","icon":"GoHomeBtn_icon__8YVz3","h4":"GoHomeBtn_h4__Lsui9"};